import {defineMessage} from 'react-intl';
import * as React from 'react';
import {setup, run} from '../../snippets/python';
import comment from '../../snippets/comment';
import {CreateShellCommand} from '../../../components/left-col';

export const steps = {
  setup,
  create: {},
  customer: {},
  'pass-customer': {},
  charge: {},
  'run-server': {
    body: {
      message: defineMessage({
        id: 'docsApp.ib.aap.server.python.run-server.body',
        defaultMessage:
          'Run your Python server and go to <a>localhost:4242/checkout.html</a>.',
      }),
      values: {
        a: (str) => (
          <a href="http://localhost:4242/checkout.html" target="_blank">
            {str}
          </a>
        ),
      },
    },
    Component: CreateShellCommand(run),
  },
};

export default ({keys, merchant}) => `#! /usr/bin/env python3.6
"""
Python 3.6 or newer required.
"""
import json
import os
{+setup}
import stripe
${comment && comment(merchant, '#')}
stripe.api_key = "${keys.secret}"
{/setup}

from flask import Flask, render_template, jsonify, request


app = Flask(__name__, static_folder="public",
            static_url_path="", template_folder="public")


def calculate_order_amount(items):
    # Replace this constant with a calculation of the order's amount
    # Calculate the order total on the server to prevent
    # people from directly manipulating the amount on the client
    return 1400


{?save-card charge}
def charge_customer(customerId):
    # Lookup the saved card (you can store multiple PaymentMethods on a Customer)
    payment_methods = stripe.PaymentMethod.list(
        customer=customerId,
        type='card'
    )

    # Charge the customer and payment method immediately
    payment_intent = stripe.PaymentIntent.create(
        amount=2000,
        currency='usd',
        customer=customerId,
        payment_method=payment_methods.data[0].id,
        off_session=True,
        confirm=True
    )

    if payment_intent.status == 'succeeded':
        print('Successfully charged card off session')


{/charge}
@app.route('/create-payment-intent', methods=['POST'])
def create_payment():
    {?save-card customer}
    # Alternatively, set up a webhook to listen for the payment_intent.succeeded event
    # and attach the PaymentMethod to a new Customer
    customer = stripe.Customer.create()

    {/customer}
    {+create}
    try:
        data = json.loads(request.data)
        {span response create}intent{/span} = stripe.PaymentIntent.create(
            {?save-card pass-customer}
            customer=customer['id'],
            setup_future_usage='off_session',
            {/pass-customer}
            amount=calculate_order_amount(data['items']),
            currency='usd'
        )

        return jsonify({
          'clientSecret': intent['client_secret']
        })
    except Exception as e:
        return jsonify(error=str(e)), 403
    {/create}

if __name__ == '__main__':
    app.run()`;
